import { z } from 'zod';

/**
 * Represents the state of a custom viz when there is not enough data to display it.
 * This can be triggered a few different ways. But this is meant to be a state called out
 * specifically when there is not enough data to display the custom viz.
 */
export const CustomVizNotEnoughDataState = z.object({
  notEnoughData: z.literal(true),
});

export type CustomVizNotEnoughDataState = z.infer<
  typeof CustomVizNotEnoughDataState
>;
